/* eslint-disable no-param-reassign */
import { OnboardingStatus } from '../entities/OnboardingStatus';
import { improvedOnboardingApi } from '../services/api/improvedOnboardingApi';

const OnboardingTaskStatusHandler = (onboardingStatuses: OnboardingStatus) =>
  improvedOnboardingApi.util.updateQueryData(
    'getOnboardingTaskStatus',
    undefined,
    onboardingStatusDraft => {
      onboardingStatusDraft.fields = onboardingStatuses.fields;
      onboardingStatusDraft.additionalFields =
        onboardingStatuses.additionalFields;
    },
  );

export default OnboardingTaskStatusHandler;
